import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, PageHeader, DirectorAvatar, DirectorProfileDialog } from "../components/common";
import { HISTORY_TIMELINE, DIRECTORS } from "../mock";

export default function History() {
  const [active, setActive] = useState(HISTORY_TIMELINE.length - 1);
  return (
    <>
      <PageHeader
        crumb="History"
        title="Decades of territory, one warehouse at a time"
        intro="Since 1996, Rajiv Syndicate Group has grown from a single retail counter to an authorised distributor for three major automotive brands across Northern Haryana."
      />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
        <Reveal><Eyebrow>The timeline</Eyebrow></Reveal>
        <div className="grid lg:grid-cols-[220px_1fr] gap-10 mt-10">
          {/* Year rail */}
          <div className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {HISTORY_TIMELINE.map((t, i) => (
              <button
                key={t.year}
                onClick={() => setActive(i)}
                className={`shrink-0 text-left font-head font-bold text-lg px-5 py-3 rounded-xl border transition-all ${
                  active === i
                    ? "bg-[var(--rs-blue)] text-white border-[var(--rs-blue)] shadow-lg"
                    : "bg-white text-[var(--rs-muted)] border-[var(--rs-border)] hover:border-[var(--rs-blue)] hover:text-[var(--rs-blue)]"
                }`}
              >
                {t.year}
              </button>
            ))}
          </div>

          {/* Detail + full list */}
          <div>
            <Reveal key={active}>
              <div className="bg-gradient-to-br from-[#eef3fe] to-[#f7f9fd] border border-[var(--rs-border)] rounded-2xl p-8 md:p-10">
                <span className="font-mono-label text-sm text-[var(--rs-blue)]">Now viewing · {HISTORY_TIMELINE[active].year}</span>
                <h3 className="font-head font-extrabold text-2xl md:text-3xl mt-3">{HISTORY_TIMELINE[active].title}</h3>
                <p className="text-[var(--rs-muted)] text-lg mt-4 leading-relaxed">{HISTORY_TIMELINE[active].body}</p>
              </div>
            </Reveal>

            <div className="mt-10 space-y-0">
              {HISTORY_TIMELINE.map((t, i) => (
                <Reveal key={t.year} delay={i * 60}>
                  <div
                    className="relative pl-8 pb-8 border-l-2 border-[var(--rs-border)] cursor-pointer group"
                    onClick={() => setActive(i)}
                  >
                    <span className={`absolute -left-[9px] top-1 w-4 h-4 rounded-full border-2 border-white transition-colors ${active === i ? "bg-[var(--rs-blue)]" : "bg-[#c7cfdb] group-hover:bg-[var(--rs-blue)]"}`} />
                    <span className="font-mono-label text-sm text-[var(--rs-blue)]">{t.year}</span>
                    <h4 className="font-head font-semibold text-lg mt-1">{t.title}</h4>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="bg-[var(--rs-bg)] border-t border-[var(--rs-border)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
          <Reveal><Eyebrow>Leadership</Eyebrow></Reveal>
          <Reveal delay={80}><h2 className="font-head font-extrabold text-3xl md:text-5xl mt-4">Directed by Sanjay Jain and Rajiv Jain</h2></Reveal>
          <Reveal delay={140}><p className="text-[var(--rs-muted)] text-lg mt-5 max-w-2xl">Family leadership has carried the Group from a single retail shop through three OEM authorisations without losing the practical, logistics-first approach it started with.</p></Reveal>
          <div className="grid md:grid-cols-2 gap-6 mt-12">
            {DIRECTORS.map((d, i) => (
              <Reveal key={d.name} delay={i * 120}>
                <DirectorProfileDialog director={d}>
                  <div className="card-hover bg-white border border-[var(--rs-border)] rounded-2xl p-8">
                    <div className="flex items-center gap-5">
                      <DirectorAvatar director={d} size={64} />
                      <div>
                        <h3 className="font-head font-bold text-xl">{d.name}</h3>
                        <p className="text-[var(--rs-blue)] text-sm font-medium">Director</p>
                      </div>
                    </div>
                    <p className="text-[var(--rs-muted)] text-sm mt-5 leading-relaxed">{d.note}</p>
                  </div>
                </DirectorProfileDialog>
              </Reveal>
            ))}
          </div>
          <Reveal delay={120}>
            <div className="flex flex-wrap gap-4 mt-12">
              <Link to="/about" className="btn-primary rounded-lg px-6 py-3 text-sm font-semibold inline-flex items-center gap-2">About the Group <ArrowRight size={16} /></Link>
              <Link to="/contact" className="btn-outline rounded-lg px-6 py-3 text-sm font-semibold">Contact Us</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
